import { useCallback } from 'react';

import { CAMERA_ANGLES } from '@core';
import type { CameraAngle } from '@data';
import { useTranslate } from '@i18n';
import { u, Text, Stack, ToggleButtonCard, Heading3 } from '@ui';

import * as css from './CameraAngleButtons.css';

interface CameraAngleButtonsProps {
    activeAngle?: CameraAngle | null;
    onUpdate: (angle: CameraAngle | null) => void;
}

export const CameraAngleButtons = ({ onUpdate, activeAngle }: CameraAngleButtonsProps) => {
    const t = useTranslate();
    const handleUpdate = useCallback(
        (value: CameraAngle) => {
            onUpdate(value === activeAngle ? null : value);
        },
        [onUpdate, activeAngle],
    );
    return (
        <Stack className={css.wrapper}>
            <Text variant="label" pb={u(2)}>
                {t('user_settings.floor_camera_options')}
            </Text>
            <div className={css.cameraAngleButtonsContainer}>
                {CAMERA_ANGLES.map((angle, index) => (
                    <ToggleButtonCard
                        key={angle}
                        isSelected={angle === activeAngle}
                        onClick={handleUpdate}
                        value={angle}
                        number={index + 1}
                    >
                        <Heading3>{t(`camera_angle.${angle}`)}</Heading3>
                    </ToggleButtonCard>
                ))}
            </div>
        </Stack>
    );
};
